import BranchIcon from "../Icons/BranchIcon";
import CityIcon from "../Icons/CityIcon";
import CogIcon from "../Icons/Cog";
import CountryIcon from "../Icons/CountryIcon";
import DistrictIcon from "../Icons/DistrictIcon";
import PaymentMethodIcon from "../Icons/PaymentMethodIcon";
import ReferenceIcon from "../Icons/ReferenceIcon";
import ServiceTypeIcon from "../Icons/ServiceTypeIcon";
import StateIcon from "../Icons/StateIcon";
import StatusIcon from "../Icons/StatusIcon";
import WarehouseIcon from "../Icons/WarehouseIcon";
import LinkCard from "../components/LinkedCard";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import ProductTypeIcon from "../Icons/ProductTypeIcon";
import RateTemplateIcon from "../Icons/RateTemplateIcon";
import RemoteAreaIcon from "../Icons/RemoteAreaIcon";
import ShipViaIcon from "../Icons/ShipViaIcon";
import { hasAccess } from "../utils/permission";
import APIS from "../constant/Endpoint";
import useTenantGetHook from "../customHooks/useTenantControlGetHook";
import Spinner from "../components/reusable/Spinner";
import BrokerIcon from "../Icons/BrokerIcon";
import GroupIcon from "../Icons/GroupIcon";

const Settings = () => {
  const { data, isLoading: isPermissionListLoading } = useTenantGetHook({
    queryKey: [`permission`],
    url: `${APIS.PERMISSION}`,
    params: {},
  });

  const permissionsLists: any = data && data?.custom_permissions;
  const navigation: any = [
    {
      name: "Country",
      href: "/address/#/country?limit=10&offset=0",
      icon: CountryIcon,
    },
    {
      name: "State",
      href: "/address/#/state?limit=10&offset=0",
      icon: StateIcon,
    },
    {
      name: "District",
      href: "/address/#/district?limit=10&offset=0",
      icon: DistrictIcon,
    },
    {
      name: "City",
      href: "/address/#/city?limit=10&offset=0",
      icon: CityIcon,
    },
      {
      name: "Group",
      href: "/address/#/group?limit=10&offset=0",
      icon: GroupIcon,
    },
    {
      name: "Status",
      href: "/status-settings?limit=10&offset=0",
      icon: StatusIcon,
    },
   

    {
      name: "Product Type",
      href: "/product-type?limit=10&offset=0",
      icon: ProductTypeIcon,
    },
    {
      name: "Branch",
      href: "/branch?limit=10&offset=0",
      icon: BranchIcon,
    },
    {
      name: "Rate Template",
      href: "/delivery-charge-template?limit=10&offset=0",
      icon: RateTemplateIcon,
    },
    {
      name: "Warehouse",
      href: "/warehouse?limit=10&offset=0",
      icon: WarehouseIcon,
    },
    {
      name: "Reference Type",
      href: "/reference-type?limit=10&offset=0",
      icon: ReferenceIcon,
    },
    {
      name: "Payment Method",
      href: "/payment-method?limit=10&offset=0",
      icon: PaymentMethodIcon,
    },
    {
      name: "Service Type",
      href: "/service-type?limit=10&offset=0",
      icon: ServiceTypeIcon,
    },
    {
      name: "Configuration",
      href: "/configuration",
      icon: ServiceTypeIcon,
    },
    ...(hasAccess(["can_view_ship_via"], permissionsLists)
      ? [
          {
            name: "Ship via",
            href: "/ship-via",
            icon: ShipViaIcon,
          },
        ]
      : []),
    ...(hasAccess(["can_view_remote_area"], permissionsLists)
      ? [
          {
            name: "Hub",
            href: "/hub",
            icon: RemoteAreaIcon,
          },
          {
            name: "Remote Area",
            href: "/remote-area",
            icon: RemoteAreaIcon,
          },
          {
            name: "Broker",
            href: "/broker",
            icon: BrokerIcon,
          },
        ]
      : []),
  ];

  return isPermissionListLoading ? (
    <Spinner />
  ) : (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 uppercase font-extrabold items-center`}
      >
        <CogIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Settings</span>
      </div>
      <div className={tw`grid gap-x-4 md:grid-cols-3 mt-6 w-full`}>
        {navigation?.map((item: any, index: number) => (
          <LinkCard
            key={index}
            label={item?.name}
            href={item?.href}
            icon={<item.icon color={"var(--primary)"} />}
          />
        ))}
      </div>
    </>
  );
};

export default Settings;
